
import { computed, defineComponent, reactive } from 'vue';
import Card from '@/core/components/Tela/Card.vue';
import CampoNumerico from '@/core/components/Tela/CampoNumerico.vue';
import SelecionarData from '@/core/components/Tela/SelecionarData.vue';
import MensagemSemDados from '@/core/components/Tela/MensagemSemDados.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { IProdutoCusto } from '@/models/Entidades/Cadastros/Produtos/IProduto';
import { ITipoCusto } from '@/models/Entidades/Cadastros/Precificacao/ITipoCusto';

export default defineComponent({
  name: 'ProdutoCustos',
  props: {
    tiposCustos: {
      type: Array as () => ITipoCusto[],
      required: true,
    },
    custos: {
      type: Array as () => IProdutoCusto[],
      required: true,
    },
    carregando: {
      type: Boolean,
      required: true,
    },
  },
  components: {
    CampoNumerico,
    SelecionarData,
    Card,
    MensagemSemDados,
  },
  emits: ['update:custos'],
  setup(props, { emit }) {
    const state = reactive({});

    const computedCustos = computed({
      get: () => props.custos,
      set: (valor: IProdutoCusto[]) => {
        emit('update:custos', valor);
      },
    });

    function obterIndex(coditoTipoCusto:number):number {
      if (UtilitarioGeral.validaLista(computedCustos.value)) {
        const index = computedCustos.value.findIndex((c) => c.codigoTipoCusto === coditoTipoCusto);
        if (index >= 0) { return index; }
      }

      return 0;
    }

    return {
      props,
      state,
      computedCustos,
      UtilitarioGeral,
      obterIndex,
    };
  },
});
